import HeartGif from "../../pics/SponsaStreamHeart.gif";
import { useSelector } from "react-redux";
import BaseURL from "../../api/BaseURL";
import { toast } from "react-toastify";
import axios from "axios";
import API from "../../api/api";
import referesh from "../../pics/Refresh.svg";
import CustomAudioPlayer from "../../components/CustomAudioPlayer";
import apisecured from "../../api/apisecured";

function StreamSetting() {
  const userlogin = useSelector((state) => state.auth);
  const userUID = userlogin.uid; // Fetch this dynamically from user data
  const alertUrl = `${BaseURL}/streamalerts?userUID=${userUID}`;
  const shareGoal = (alertUrl) => {
    // Use the Clipboard API to copy the URL
    navigator.clipboard
      .writeText(alertUrl)
      .then(() => {
        toast.success("Stream Alert URL copied to clipboard.");
      })
      .catch((err) => {
        console.error("Could not copy the URL to clipboard", err);
      });
  };
  // Function to send test alert
  const sendTestAlert = async () => {
    const testAlertData = {
      userUID: userUID,
      donorName: "TestUser",
      amount: 5.0,
      currency: userlogin.currency,
      goalTitle: "Test Goal",
    };

    try {
      // const response = await axios.post(`${BaseURL}/test-alert`, testAlertData);
      const response = await apisecured.post("goals/test-alert", testAlertData);

      if (response.status === 200) {
        toast.success("Test alert sent successfully!");
      } else {
        toast.error(`Failed to send test alert: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error sending test alert:", error);
      toast.error("Failed to send test alert. Please try again.");
    }
  };
  return (
    <>
      <div className="bg-[#35334D] py-8 md:px-10 sm:px-6 px-4 relative ">
        <h2
          className="CustomCardPara  !font-bold "
          style={{ fontFamily: "Gilroy", fontWeight: "700" }}
        >
          Stream Alerts
        </h2>

        <h2 className="CustomSignUpLabel !font-medium  !ml-0 mt-3  ">
          Copy and paste this URL as a Browser Source in OBS to show an animated
          alert whenever you receive a tip!
        </h2>
        <div className="rounded-[10px]  bg-[#030021] md:h-[52px]  w-full  ">
          <div className="rounded-[10px]  bg-[#35334D99] h-full  p-4 mt-6  relative w-full ">
            <p
              className=" text-white text-left font-semibold text-[15px] leading-[18.38px] tracking-[0%]  break-words overflow-x-auto  whitespace-nowrap  scrollbar-hide "
              style={{ width: "80%", scrollbarWidth: "none" }}
            >
              {alertUrl}
            </p>
            <button
              onClick={(e) => {
                e.stopPropagation();
                shareGoal(alertUrl);
              }}
              className=" md:w-[80px] md:h-[40px] w-[50px] h-[30px] absolute top-[50%] translate-y-[-50%] right-1.5  font-bold text-[15px] leading-[18.57px] tracking-[0%] HoverDarker CustomButtonAnim text-[#030021] bg-[#00FF8F]  rounded-[10px] !text-center  "
            >
              Copy
            </button>
          </div>
        </div>
        <h2 className="CustomSignUpLabel !font-medium   !ml-0 mt-3  ">
          Preview
        </h2>
        <div className="rounded-[10px]  bg-[#030021]  ">
          <div className="rounded-[10px]  bg-[#35334D99] space-y-3 p-6 mt-4 flex flex-col items-center ">
            {/* <img
              src={
                "https://sponsaapi.validatione.com/Assets/Goals/DefaultGifSponsa.gif"
              }
              alt=""
              width={200}
              height={200}
            /> */}
            <video
              src="https://api.sponsa.app/Assets/Goals/DefaultVideoSponsa.webm"
              className="w-[300px]"
              autoPlay
              loop
              muted
              playsInline
            />
            <p className="text-white text-center font-semibold text-[15px] leading-[18.38px] tracking-[0%]">
              <span className="text-[#00FF8F] font-bold">{`{name}`}</span>{" "}
              tipped
              <span className="text-[#00FF8F] font-bold">{` {amount}`}</span>{" "}
              towards
              <span className="text-[#00FF8F] font-bold">{` {goal}`}</span>.
              Thank you!
            </p>
          </div>
        </div>
        <button
          className="font-bold text-[15px] leading-[18.57px] tracking-[0%]  block CustomButtonAnim text-[#030021] bg-[#00FF8F]  rounded-[25px] mx-auto px-[2rem] py-[0.5rem] mt-4 HoverDarker "
          onClick={sendTestAlert}
        >
          Test Alert
        </button>
      </div>

      {/* Premium Features */}

      {/* <div className="bg-[#35334D] py-8 md:px-10 sm:px-6 px-4 relative ">
        <h2
          className="CustomCardPara  !font-bold "
          style={{ fontFamily: "Gilroy", fontWeight: "700" }}
        >
          Stream Alerts Customisation
        </h2>
        <h2 className="CustomSignUpLabel  !font-medium !ml-0 mt-4  ">
          Customise your alert text, sound and animation here!{" "}
        </h2>
        <div className=" flex items-center justify-between gap-2 mt-4 ">
          <div className=" space-y-1 ">
            <p className=" text-white font-semibold text-[15px] leading-[18.38px] tracking-[0%]   ">
              Alert Text
            </p>
            <p className=" text-white font-normal text-[15px] leading-[18.38px] tracking-[0%]   ">
              This is the text that appears when you receive a tip. Available
              variables: {`{name}, {amount}, {goal}`}{" "}
            </p>
          </div>
          <button className="font-bold text-[15px] leading-[18.57px] tracking-[0%]   CustomButtonAnim text-[#030021] bg-white  rounded-[25px] min-w-[106px]  w-[106px] h-[36px] mt-4 flex items-center justify-center gap-0.5 ">
            <img src={referesh} alt="" width={20} height={20} />
            Reset
          </button>
        </div>
        <div className="rounded-[10px]  bg-[#030021] md:h-[52px] w-full  ">
          <div className="rounded-[10px]  bg-[#35334D99] h-full  p-4 mt-6  relative w-full ">
            <p className=" text-white text-left font-semibold text-[15px] leading-[18.38px] tracking-[0%]  ">
              {`{name} tipped {amount} towards {goal}. Thank you!`}
            </p>
          </div>
        </div>
        <div className=" flex items-center justify-between gap-2 mt-16 ">
          <div className=" space-y-1 ">
            <p className=" text-white font-semibold text-[15px] leading-[18.38px] tracking-[0%]   ">
              Alert Sound
            </p>
            <p className=" text-white font-normal text-[15px] leading-[18.38px] tracking-[0%]   ">
              This is the sound that plays when you receive a tip.
            </p>
          </div>
          <button className="font-bold text-[15px] leading-[18.57px] tracking-[0%]   CustomButtonAnim text-[#030021] bg-white  rounded-[25px] min-w-[106px]  w-[106px] h-[36px] mt-4 flex items-center justify-center gap-0.5 ">
            <img src={referesh} alt="" width={20} height={20} />
            Reset
          </button>
        </div>
        <div>
          <div className="mt-4 mb-6  ">
            <CustomAudioPlayer
              source={
                "https://sponsaapi.validatione.com/Assets/Goals/default.ogg.ogg"
              }
            />
          </div>
          <div className=" flex items-center justify-start gap-2  ">
            <button className="font-bold text-[15px] leading-[18.57px] tracking-[0%]  block CustomButtonAnim text-[#030021] bg-[#00FF8F]  rounded-[25px]  px-[2rem] py-[0.5rem]  ">
              Choose File
            </button>
            <p className="text-white font-normal text-[15px] leading-[18.38px] tracking-[0%]  ">
              defaultsound.ogg
            </p>
          </div>
        </div>
        <div className=" flex items-center justify-between gap-2 mt-16 ">
          <div className=" space-y-1 ">
            <p className=" text-white font-semibold text-[15px] leading-[18.38px] tracking-[0%]   ">
              Alert Animation
            </p>
            <p className=" text-white font-normal text-[15px] leading-[18.38px] tracking-[0%]   ">
              This is the animation that plays when you receive a tip.
            </p>
          </div>
          <button className="font-bold text-[15px] leading-[18.57px] tracking-[0%]   CustomButtonAnim text-[#030021] bg-white  rounded-[25px] min-w-[106px]  w-[106px] h-[36px] mt-4 flex items-center justify-center gap-0.5 ">
            <img src={referesh} alt="" width={20} height={20} />
            Reset
          </button>
        </div>
        <div>
          <div className="mt-4 mb-6  ">
            <div className="rounded-[10px]  bg-[#030021]  ">
              <div className="rounded-[10px]  bg-[#35334D99] space-y-3 p-6 mt-4 flex flex-col items-center ">
                <img src={heaetr} alt="" width={200} height={200} />
                <p className=" text-white text-center font-semibold text-[15px] leading-[18.38px] tracking-[0%]  ">
                  {` {name} tipped {amount} towards {goal}. Thank you!`}
                </p>
              </div>
            </div>
          </div>
          <div className=" flex items-center justify-start gap-2  ">
            <button className="font-bold text-[15px] leading-[18.57px] tracking-[0%]  block CustomButtonAnim text-[#030021] bg-[#00FF8F]  rounded-[25px]  px-[2rem] py-[0.5rem]  ">
              Choose File
            </button>
            <p className="text-white font-normal text-[15px] leading-[18.38px] tracking-[0%]  ">
              defaultsound.ogg
            </p>
          </div>
        </div>
      </div> */}

      {/* Premium Features */}
    </>
  );
}

export default StreamSetting;
